import * as React from 'react'

import { TQCustomerVariables, useQCustomer } from '~graphql/generated/clientGraphql'
import { useAuthCtx, useAuthStateCtx } from '~logic/auth/AuthProvider'

import { useCustomerOperationContext } from './useCustomerOperationContext'

/**
 * Loads customer information such as name, phone number or email.
 */
export const useLoadCustomer = () => {
  const { isLoggedIn } = useAuthStateCtx()
  const { userId } = useAuthCtx()

  const context = useCustomerOperationContext()

  const variables = React.useMemo<TQCustomerVariables | undefined>(() => {
    if (!isLoggedIn || !userId) return undefined

    return { id: userId }
  }, [isLoggedIn, userId])

  const { data, refetch } = useQCustomer({
    variables,
    context,
    skip: !variables,
  })

  const isCurrentCustomerData = data?.customer.id === userId

  if (!isLoggedIn || !isCurrentCustomerData) {
    return {
      customer: null,
      refetchCustomer: refetch,
    }
  }

  return {
    customer: data?.customer ?? null,
    refetchCustomer: refetch,
  }
}
